import React, { useState } from 'react'
import { Row, Col, SelectPicker, Input, Panel } from 'rsuite'
import SearchButton from '../../../components/buttons/searchButton/SearchButton'
import CancelButton from '../../../components/buttons/cancelButton/CancelButton'
import { sessionGetItemObj } from '../../../utils/sessionHelpers'
import DatePickerCustom from '../../../components/datePicker/DatePickerCustom'
import moment from 'moment'

export default function BlacklistedSearchForm({
  schema,
  loading,
  onDelete,
  onSelect,
  onPreview,
  onSearch = () => {},
  ...props
}) {
  const [blacklistType, setฺBlacklistType] = useState()
  const [blacklistAbandonmentType, setBlacklistAbandonmentType] = useState()
  const [idCard, setIdCard] = useState()
  const [personName, setPersonName] = useState()
  const [taxNumber, setTaxNumber] = useState()
  const [juristicName, setJuristicName] = useState()
  const [startDate, setStartDate] = useState()
  const [endDate, setEndDate] = useState()

  // console.log('schema ', schema)
  return (
    <>
      <Panel bordered header={'ค้นหา'} collapsible defaultExpanded>
        <div style={{ marginTop: -10, marginBottom: -10 }}>
          <Row style={{ marginBottom: 10 }}>
            <Col lg={4} md={4} sm={24} xs={24}></Col>
            <Col lg={8} md={8} sm={24} xs={24}>
              {schema.blacklistType.label}
              <SelectPicker
                searchable={false}
                value={blacklistType}
                data={schema.blacklistType.options}
                block
                onChange={(value) => {
                  setฺBlacklistType(value)
                }}
              />
            </Col>

            <Col lg={8} md={8} sm={24} xs={24}>
              {schema.blacklistAbandonmentType.label}
              <SelectPicker
                searchable={false}
                value={blacklistAbandonmentType}
                data={schema.blacklistAbandonmentType.options}
                block
                onChange={(value) => {
                  setBlacklistAbandonmentType(value)
                }}
              />
            </Col>
            <Col lg={4} md={4} sm={24} xs={24}></Col>
          </Row>

          <Row style={{ marginBottom: 10 }}>
            <Col lg={4} md={4} sm={24} xs={24}></Col>
            <Col lg={8} md={8} sm={24} xs={24}>
              {schema.idCard.label}
              <Input
                value={idCard}
                onChange={(value) => {
                  setIdCard(value)
                }}
              />
            </Col>

            <Col lg={8} md={8} sm={24} xs={24}>
              {schema.personName.label}
              <Input
                value={personName}
                onChange={(value) => {
                  setPersonName(value)
                }}
              />
            </Col>
            <Col lg={4} md={4} sm={24} xs={24}></Col>
          </Row>

          <Row style={{ marginBottom: 10 }}>
            <Col lg={4} md={4} sm={24} xs={24}></Col>
            <Col lg={8} md={8} sm={24} xs={24}>
              {schema.taxNumber.label}
              <Input
                value={taxNumber}
                onChange={(value) => {
                  setTaxNumber(value)
                }}
              />
            </Col>

            <Col lg={8} md={8} sm={24} xs={24}>
              {schema.juristicName.label}
              <Input
                value={juristicName}
                onChange={(value) => {
                  setJuristicName(value)
                }}
              />
            </Col>
            <Col lg={4} md={4} sm={24} xs={24}></Col>
          </Row>

          <Row style={{ marginBottom: 10 }}>
            <Col lg={4} md={4} sm={24} xs={24}></Col>
            <Col lg={8} md={8} sm={24} xs={24}>
              {schema.startDate.label}
              <DatePickerCustom
                {...props}
                placement="auto"
                value={startDate}
                disabledDate={(date) => endDate && moment(endDate).isBefore(date, new Date())}
                onChange={(value) => {
                  setStartDate(value)
                }}
              />
            </Col>

            <Col lg={8} md={8} sm={24} xs={24}>
              {schema.endDate.label}
              <DatePickerCustom
                {...props}
                placement="auto"
                value={endDate}
                disabledDate={(date) => startDate && moment(startDate).isAfter(date, new Date())}
                onChange={(value) => {
                  setEndDate(value)
                }}
              />
            </Col>
            <Col lg={4} md={4} sm={24} xs={24}></Col>
          </Row>

          <Row style={{ marginTop: 20 }}>
            <Col lg={4} md={4} sm={24} xs={24}></Col>
            <Col lg={8} md={8} sm={24} xs={24}>
              <SearchButton
                disabled={loading}
                onClick={() => {
                  let request = {
                    startDate: startDate ? moment(startDate).format('YYYY-MM-DD') : '',
                    endDate: endDate ? moment(endDate).format('YYYY-MM-DD') : '',
                    blacklistType: blacklistType,
                    blacklistAbandonmentType: blacklistAbandonmentType,
                    idCard: idCard,
                    personName: personName,
                    taxNumber: taxNumber,
                    juristicName: juristicName,
                  }
                  onSearch(request)
                }}
                style={{ marginTop: 0, marginLeft: 0 }}
              >
                ค้นหา
              </SearchButton>
              <CancelButton
                onClick={() => {
                  setฺBlacklistType('')
                  setBlacklistAbandonmentType('')
                  setIdCard('')
                  setPersonName('')
                  setTaxNumber('')
                  setJuristicName('')
                  setStartDate(null)
                  setEndDate(null)

                  onSearch({})
                }}
                style={{ marginTop: 0, marginLeft: 10 }}
              >
                ยกเลิก
              </CancelButton>
            </Col>
          </Row>
        </div>
      </Panel>
    </>
  )
}
